module.exports = __webpack_public_path__ + "media/images/favicons/favicon-tuesday-32x32-9640f1d4c8fdee0a3459eba4dd508b75.png";